var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehcile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11643_47714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3422 3.2625C21.0867 2.525 20.3711 2 19.5278 2H5.47222C4.62889 2 3.92611 2.525 3.65778 3.2625L1 10.75V20.75C1 21.4375 1.575 22 2.27778 22H3.55556C4.25833 22 4.83333 21.4375 4.83333 20.75V19.5H20.1667V20.75C20.1667 21.4375 20.7417 22 21.4444 22H22.7222C23.425 22 24 21.4375 24 20.75V10.75L21.3422 3.2625ZM5.47222 15.75C4.41167 15.75 3.55556 14.9125 3.55556 13.875C3.55556 12.8375 4.41167 12 5.47222 12C6.53278 12 7.38889 12.8375 7.38889 13.875C7.38889 14.9125 6.53278 15.75 5.47222 15.75ZM19.5278 15.75C18.4672 15.75 17.6111 14.9125 17.6111 13.875C17.6111 12.8375 18.4672 12 19.5278 12C20.5883 12 21.4444 12.8375 21.4444 13.875C21.4444 14.9125 20.5883 15.75 19.5278 15.75ZM3.55556 9.5L5.47222 3.875H19.5278L21.4444 9.5H3.55556Z",
    fill: "#F2F2F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11643_47714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehcile);
export default __webpack_public_path__ + "static/media/vehcile.8863a9c32f3a628a153db3a64d7a69a0.svg";
export { ForwardRef as ReactComponent };